import {useCallback, useMemo} from 'react'
import {useDidMount} from 'utils'
import {useSelector} from 'lib/redux'
import {handleGiftshopGetCreator} from 'repositories'

export function useGiftshopUploadCompressResendSetting() {
  const {
    creatorStatus = 'unverified',
    compressEnabled: compressEnabledRedux,
    resendEnabled: resendEnabledRedux,
  } = useSelector('yuserActivationState')
  const {id} = useSelector('user')!

  const handleLoadData = useCallback(() => {
    if (id) {
      handleGiftshopGetCreator()
    }
  }, [id])

  const compressEnabled = useMemo(
    () => compressEnabledRedux ?? creatorStatus === 'verified',
    [compressEnabledRedux, creatorStatus],
  )

  const resendEnabled = useMemo(
    () => resendEnabledRedux ?? creatorStatus === 'verified',
    [resendEnabledRedux, creatorStatus],
  )

  const validated = useMemo(
    () =>
      compressEnabledRedux !== undefined && resendEnabledRedux !== undefined,
    [compressEnabledRedux, resendEnabledRedux],
  )

  useDidMount(handleLoadData)

  return useMemo(
    () => ({
      compressEnabled,
      resendEnabled,
      validated,
    }),
    [compressEnabled, resendEnabled, validated],
  )
}
